// Supabase client — used by the cloud-sync layer to back up trees and pull
// on cross-device launches, and by the auth layer to gate access to the app.
// The anon key is designed to be public; pair with Row Level Security
// policies (see supabase/schema.sql and supabase/profiles.sql).

import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = !!(url && anonKey);

// noLock bypasses the SDK's navigator.locks-based session serializer.
// We need it because the default lock has been observed to wedge
// silently on Railway, causing getSession() to hang past the 5-second
// boot timeout.
//
// The race condition this lock was originally protecting against (the
// spurious SIGNED_OUT mid-sign-in that wiped state) is now handled in
// AuthContext.js by userSignedOutRef — non-user-initiated SIGNED_OUT
// events are ignored, so the spurious event is harmless.
const noLock = async (_name, _acquireTimeout, fn) => fn();

export const supabase = supabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        lock: noLock,
      },
    })
  : null;
